export const corsproxyRequest = async (url: string) => {
  try {
    // First try a direct fetch
    const directResponse = await fetch(url);
    if (!directResponse.ok) {
      throw new Error("Network response was not OK");
    }
    return await directResponse.json();
  } catch (error) {
    // If direct fetch fails (likely due to CORS), use the proxy
    return new Promise((resolve, reject) => {
      fetch(
        `${import.meta.env.VITE_FIREBASE_CLOUD_FUNCTIONS_URL}/apiNoCorsFetch`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ url }),
        }
      ).then((res) => {
        if (!res.ok) {
          reject(new Error("Network response was not OK"));
          return;
        }
        res.json().then(resolve);
      });
    });
  }
};
  